import axios from '@/utils/axios';
import {
  ServiceBlockedDate,
  ServiceBlockedDateFilters,
  ServiceBlockedDatePayload,
} from '../types';

const cleanFilters = (filters: ServiceBlockedDateFilters = {}) =>
  Object.entries(filters).reduce<Record<string, string | number>>(
    (params, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value;
      }

      return params;
    },
    {}
  );

const normalizeBlockedDate = (
  blockedDate: ServiceBlockedDate
): ServiceBlockedDate => ({
  ...blockedDate,
  city: blockedDate.city ?? blockedDate.cities ?? null,
  service_variant: blockedDate.service_variant
    ? {
        ...blockedDate.service_variant,
        name:
          blockedDate.service_variant.variant_name ??
          blockedDate.service_variant.name,
      }
    : null,
});

export async function getServiceBlockedDates(
  filters?: ServiceBlockedDateFilters
): Promise<ServiceBlockedDate[]> {
  const {
    data: { data },
  } = await axios.get('/services/blocked-dates', {
    params: cleanFilters(filters),
  });

  return data.map(normalizeBlockedDate);
}

export async function getServiceBlockedDate(
  id: string
): Promise<ServiceBlockedDate> {
  const {
    data: { data },
  } = await axios.get(`/services/blocked-dates/${id}`);

  return normalizeBlockedDate(data);
}

export async function createServiceBlockedDate(
  payload: ServiceBlockedDatePayload
) {
  const { data } = await axios.post('/services/blocked-dates', payload);
  return data;
}

export async function updateServiceBlockedDate(
  id: string,
  payload: ServiceBlockedDatePayload
) {
  const { data } = await axios.put(`/services/blocked-dates/${id}`, payload);
  return data;
}

export async function deleteServiceBlockedDate(id: string) {
  await axios.delete(`/services/blocked-dates/${id}`);
}
